import React, { useEffect, useState } from 'react';
import { Grid } from '@mui/material';
import RichTextEditor from 'react-rte';
import { useDispatch, useSelector } from 'react-redux';
import * as StaticPageActions from '../../../redux/actions/staticPageAction';

const TermsAndConditions = () => {
    const dispatch = useDispatch();
    const { termsAndConditionData } = useSelector(state => state?.staticPageReducer);

    const [description, setDescription] = useState(RichTextEditor.createEmptyValue());
    const [inputFieldError, setInputFieldError] = useState({ title: '' });

    //* Handle Input Field : Error
    const handleInputFieldError = (input, value) => {
        setInputFieldError((prev) => ({ ...prev, [input]: value }))
    }

    //! Handle Validation
    const handleValidation = () => {
        let isValid = true;

        if (description?.toString('html') == "<p><br></p>") {
            handleInputFieldError("description", "Please Enter Description")
            isValid = false;
        }

        return isValid;
    };

    //! Handle Submit
    const handleSubmit = async (e) => {
        e.preventDefault();
        console.log({ description: description?.toString('html') })

        if (handleValidation()) {
            //! Dispatching API For Updating Terms and Conditions
            const payload = {
                termsAndCondition: description?.toString('html')
            }

            dispatch(StaticPageActions.createTermsAndCondition(payload));
        }
    };

    useEffect(() => {
        //! Dispatching API For Getting Terms and Conditions
        dispatch(StaticPageActions.getTermsAndCondition());
    }, [])

    useEffect(() => {
        setDescription(RichTextEditor.createValueFromString(String(termsAndConditionData), 'html'))
    }, [termsAndConditionData]);

    return (
        <>
            <div style={{ padding: "20px", backgroundColor: "#fff", marginBottom: "20px", boxShadow: '0px 0px 5px lightgrey', borderRadius: "10px" }}>
                <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "30px", fontFamily: 'Philosopher', backgroundColor: "#fff" }}>
                    <div style={{ fontSize: "20px", fontWeight: "600", color: "#667284" }}>Terms and Conditions</div>
                </div>

                <Grid container spacing={2}>
                    <Grid item lg={12} md={12} sm={12} xs={12}>
                        <RichTextEditor
                            value={description}
                            onChange={setDescription}
                            editorStyle={{ minHeight: '50vh', }}
                            onFocus={() => handleInputFieldError("description", null)}
                        />
                        {inputFieldError?.description && <div style={{ color: "#D32F2F", fontSize: "13px", padding: "5px 15px 0 12px", fontWeight: "400" }}>{inputFieldError?.description}</div>}
                    </Grid>

                    <Grid item lg={12} md={12} sm={12} xs={12}>
                        <Grid container sx={{ justifyContent: "space-between" }}>
                            <div onClick={handleSubmit} style={{ fontWeight: "500", backgroundColor: "#164E62", color: "#fff", padding: "10px 20px", borderRadius: "5px", cursor: "pointer", fontSize: "15px" }}>Submit</div>
                        </Grid>
                    </Grid>
                </Grid>
            </div>
        </>
    )
}

export default TermsAndConditions;